import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog'

interface ReuniaoAoVivoDialogsProps {
  showEncerrarDlg: boolean
  setShowEncerrarDlg: (v: boolean) => void
  showCancelDlg: boolean
  setShowCancelDlg: (v: boolean) => void
  isRec: boolean
  isMeet?: boolean
  onEncerrar: () => void
  onConfirmCancel: () => Promise<void>
}

export default function ReuniaoAoVivoDialogs({
  showEncerrarDlg, setShowEncerrarDlg,
  showCancelDlg, setShowCancelDlg,
  isRec, isMeet, onEncerrar, onConfirmCancel,
}: ReuniaoAoVivoDialogsProps) {
  return (
    <>
      <AlertDialog open={showEncerrarDlg} onOpenChange={setShowEncerrarDlg}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Encerrar reunião?</AlertDialogTitle>
            <AlertDialogDescription>
              {isMeet
                ? 'O cronômetro será parado e a sessão finalizada. A transcrição do Google Meet será importada automaticamente.'
                : 'A gravação será salva, o cronômetro parado e a sessão finalizada. A transcrição será gerada automaticamente em segundo plano.'}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => { setShowEncerrarDlg(false); onEncerrar() }}
              className="bg-[var(--color-vermelho)] hover:bg-[var(--color-vermelho)]/80">
              Encerrar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={showCancelDlg} onOpenChange={setShowCancelDlg}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sair sem salvar?</AlertDialogTitle>
            <AlertDialogDescription>
              A sessão será descartada. Anotações, tarefas e o horário de início serão apagados.
              A reunião voltará para AGENDADA.
              {isRec && ' A gravação em andamento também será descartada.'}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Continuar sessão</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => { setShowCancelDlg(false); onConfirmCancel() }}
              className="bg-[var(--color-vermelho)] hover:bg-[var(--color-vermelho)]/80">
              Sair sem salvar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  )
}
